// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2wKcp","savePackageButton":"ClientWallet_savePackageButton__3cTPp"};